import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { init } from '@module-federation/runtime'
import './index.css'
import App from './App'

// Initialize Module Federation runtime — must happen before any loadRemote calls
// This sets up the shared dependency resolution and CSS injection handlers
init({
  name: 'shell_app',
  remotes: [],
});

// Import favicon
import favicon from '/icons/favicon.ico'

// Set favicon dynamically
const link = document.querySelector("link[rel~='icon']");
if (link) {
  link.href = favicon;
}

// Fix for vh units on mobile
function setVhVariable() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Set the variable initially and on resize
setVhVariable();
window.addEventListener('resize', setVhVariable);

// Global configuration for sharing with micro-frontends
window.__APP_CONFIG__ = {
  apiUrl: import.meta.env.VITE_API_URL,
  version: '1.0.0',
  environment: import.meta.env.MODE
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)